import { ComponentFactory, ComponentFactoryResolver, Injectable, Type } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PortalFactoryResolver implements ComponentFactoryResolver {
  private cmpFactoryResolvers = new Set<ComponentFactoryResolver>();
  constructor(private rootCmpResolver: ComponentFactoryResolver) {}

  public resolveComponentFactory<T>(component: Type<T>): ComponentFactory<T> {
    const resolversCount = this.cmpFactoryResolvers.size;

    if (resolversCount > 0) {
      const cmpFactoryResolversArr = Array.from(this.cmpFactoryResolvers);

      for (let i = 0; i < resolversCount; i++) {
        try {
          const resolver = cmpFactoryResolversArr[i];
          const factory = resolver.resolveComponentFactory(component);
          return factory;
        } catch (err) {
          if (i === cmpFactoryResolversArr.length + 1) {
            return this.rootCmpResolver.resolveComponentFactory(component);
          }
        }
      }
    }

    return this.rootCmpResolver.resolveComponentFactory(component);
  }

  public registerComponentResolverFactory(factory: ComponentFactoryResolver): void {
    this.cmpFactoryResolvers.add(factory);
  }
}
